import { Alert, Snackbar } from "@mui/material";

export default function NetworkFailureToast({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
    >
      <Alert
        onClose={onClose}
        severity="error"
        variant="filled"
        sx={{ width: "100%" }}
      >
        An unexpected error occurred and the request could not be completed.
        Please try again.
      </Alert>
    </Snackbar>
  );
}
